import React from "react";
import { VStack, Icon, Flex, Link } from "@chakra-ui/react";
import { IoLockClosed, IoPerson } from "react-icons/io5";
import { Link as RouterLink } from "react-router-dom";
import { TextInput, Form } from "components";
import { utils, hooks, Types } from "./duck";

const Login: React.FC = () => {
  const login = hooks.useLogin();

  return (
    <Form<Types.FormValues>
      {...utils.getValidation()}
      width="21.25rem"
      onSubmit={login}
    >
      <VStack spacing={6}>
        <TextInput
          name="username"
          label="Username"
          labelHidden
          placeholder="Username"
          inputLeftElementProps={{
            children: <Icon as={IoPerson} color="gray.400" w={5} h={5} />
          }}
        />
        <TextInput
          type="password"
          name="password"
          label="Password"
          labelHidden
          placeholder="Password"
          inputLeftElementProps={{
            children: <Icon as={IoLockClosed} color="gray.400" w={5} h={5} />
          }}
        />

        <Form.Controls
          w="full"
          submitText="Login"
          submitProps={{ w: "full" }}
        />
      </VStack>

      <Flex mt="4" w="full" justifyContent="end">
        <Link
          as={RouterLink}
          to="/password-recovery"
          _focus={{ border: "initial" }}
          color="basic.500"
          fontWeight={600}
        >
          Forgot password?
        </Link>
      </Flex>
    </Form>
  );
};

export default Login;
